/// From https://reactjsexample.com/responsive-tabs-with-react-js/
/// (https://maslianok.github.io/react-responsive-tabs/)
/// Licence: MIT
import classnames from 'classnames';
import React, { PureComponent } from 'react';

const styles = require('./tab-panel.css');

export interface TabPanelProps {
  /// TODO This should be a union: either getContent() or child nodes
  getContent?(): void;
  children?: React.ReactNode; /// Defined as Array | Object | string
  /** = key */
  id: string;
  classNames?: string;
  /** Tab ID string to give aria label */
  tabId: string;
}

export class TabPanel extends PureComponent<TabPanelProps> {
  /// "shouldComponentUpdate() is invoked before rendering when new props or state are being received. Defaults to true.
  ///  This method is not called for the initial render or when forceUpdate() is used.
  /// "This method only exists as a performance optimization. Do not rely on it to “prevent” a rendering, as this can
  ///  lead to bugs. Consider using the built-in PureComponent instead of writing shouldComponentUpdate() by hand.
  ///  PureComponent performs a shallow comparison of props and state, and reduces the chance that you’ll skip a necessary
  ///  update."
  //   shouldComponentUpdate(nextProps: TabPanelProps) {
  //     const { children, getContent, classNames } = this.props;
  //     return (
  //       getContent !== nextProps.getContent || children !== nextProps.children || classNames !== nextProps.classNames
  //     );
  //   }

  render = () => {
    const { getContent, children, id, classNames, tabId } = this.props;

    const className = classNames ? classnames(classNames, styles.panel) : styles.panel;

    return (
      <div className={className} role="tabpanel" id={id} aria-labelledby={tabId} aria-hidden="false">
        {getContent && getContent()}
        {!getContent && children}
      </div>
    );
  };
}

/// Not required cos Typescript
// TabPanel.propTypes = {
//   getContent: PropTypes.func,
//   children: PropTypes.oneOfType([PropTypes.array, PropTypes.object, PropTypes.string]),
//   id: PropTypes.string.isRequired,

//   // generic props
//   classNames: PropTypes.string.isRequired,
//   tabId: PropTypes.string.isRequired
// };

// TabPanel.defaultProps = {
//   getContent: undefined,
//   children: undefined
// };



// WEBPACK FOOTER //
// ./src/ui/components/tab-panel/tab-panel.tsx